import { format } from "date-fns";
import { Information } from "features/History/HistoryDetail/fetchHistoryDetail";
import { FC } from "react";
import { Flex, Text } from "shared/components/Spor";

type HeaderProps = {
  information: Information;
};

export const DetailsHeader: FC<HeaderProps> = ({ information }) => (
  <Flex gap="8px" alignItems="center">
    <Text style={{ fontSize: "30px" }} fontWeight="bold">
      {information.type.label ?? "-"}
    </Text>
    <Text style={{ fontSize: "24px" }} color="text.highlight">
      / {format(information.createdAt, "dd.MM.yyyy")}
    </Text>
    {information.stretchName && (
      <Text style={{ fontSize: "24px" }} color="text.highlight">
        / {information.stretchName}
      </Text>
    )}
  </Flex>
);
